(() => {
 const root=document.querySelector('.oa'); if(!root || root.dataset.navReady) return;
 root.dataset.navReady='true';
 const bar=root.querySelector('.oa-category-bar'), nav=root.querySelector('.oa-category-nav');
 if(!bar || !nav) return;
 const links=[...nav.querySelectorAll('a')], groups=[...root.querySelectorAll('.oa-group')];
 const header=document.querySelector('.section-header');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let pending=false, active='';
 function update(){
  pending=false;
  const top=header?Math.max(0,header.getBoundingClientRect().bottom):0;
  root.style.setProperty('--oa-header',top+'px');
  root.style.setProperty('--oa-offset',(top+bar.offsetHeight+20)+'px');
  let current=groups[0];groups.forEach(g=>{if(g.getBoundingClientRect().top<=top+bar.offsetHeight+45)current=g;});
  if(!current || active===current.id)return;
  active=current.id;
  links.forEach(link=>{
   if(link.hash==='#'+active){link.setAttribute('aria-current','location');nav.scrollTo({left:link.offsetLeft-nav.offsetLeft-(nav.clientWidth-link.offsetWidth)/2,behavior:reduced.matches?'auto':'smooth'});}
   else link.removeAttribute('aria-current');
  });
 }
 function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
 links.forEach(link=>link.addEventListener('click',event=>{
  const target=groups.find(g=>'#'+g.id===link.hash);if(!target)return;
  event.preventDefault();update();
  const offset=parseFloat(getComputedStyle(root).getPropertyValue('--oa-offset'))||160;
  window.scrollTo({top:target.getBoundingClientRect().top+scrollY-offset,behavior:reduced.matches?'auto':'smooth'});
  history.replaceState(null,'',link.hash);
 }));
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
 if(header)new ResizeObserver(schedule).observe(header);
 update();
})();
